import { render, staticRenderFns } from "./ContractSelectByClientOrProviderUpdateDialog.vue?vue&type=template&id=d575f540&"
import script from "./ContractSelectByClientOrProviderUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./ContractSelectByClientOrProviderUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
